import { LitElement, html, svg, css } from 'lit';
import { property } from 'lit/decorators.js';

export interface BaseIconProps {
  size: number;
  color: string;
}

export class BaseIcon extends LitElement {
  static override styles = css`
    :host {
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  `;

  @property({ type: Number, attribute: 'size', reflect: true })
  size: number = 16;

  @property({ type: String, attribute: 'color', reflect: true })
  color: string = 'currentcolor';

  override attributeChangedCallback(
    name: string,
    old: string | null,
    value: string | null,
  ) {
    super.attributeChangedCallback(name, old, value);
    this.requestUpdate();
  }

  viewBox: string = '0 0 448 512';

  override render() {
    return html`
      <svg
        width=${this.size}
        xmlns="http://www.w3.org/2000/svg"
        viewBox=${this.viewBox}
        fill=${this.color}
        stroke=${this.color}
      >
        ${this.content()}
      </svg>
    `;
  }

  content() {
    return svg``;
  }
}
